import React from 'react';

// FloatingCTA disabled to avoid overlap with platform badge
const FloatingCTA = () => {
  return null;
};

export default FloatingCTA;
